import {Routes} from "@angular/router";

export const ROUTES: Routes = [
  {
    path: '',
    loadChildren: () => import('./core/main/main.routes')
  },
  {
    path: 'login',
    loadChildren: () => import('./features/auth/auth.routes')
  },
  {
    path: 'catalog',
    loadChildren: () => import('./features/catalog/catalog.routes')
  },
  {
    path: 'orders',
    loadChildren: () => import('./features/orders/orders.routes')
  },
  {
    path: 'order-assembly',
    loadChildren: () => import('./features/order-assembly/order-assembly.routes')
  },
  {
    path: 'store',
    loadChildren: () => import('./features/store/store.routes')
  },
  {
    path: 'management',
    loadChildren: () => import('./features/management/management.routes')
  },
  {
    path: 'reports',
    loadChildren: () => import('./features/reports/reports.routes')
  }
];
